"use client";

import { cn } from "@/utils";

type ChartLegendToggleAllProps = {
  lineKeys: string[];
  hidden: string[];
  onHiddenChange: (hidden: string[]) => void;
  className?: string;
};

export function ChartLegendToggleAll({
  lineKeys,
  hidden,
  onHiddenChange,
  className,
}: ChartLegendToggleAllProps) {
  if (lineKeys.length === 0) return null;

  const allHidden = lineKeys.every((key) => hidden.includes(key));

  return (
    <button
      type="button"
      aria-label={allHidden ? "Show all series" : "Hide all series"}
      onClick={() => onHiddenChange(allHidden ? [] : [...lineKeys])}
      className={cn(
        "rounded-lg border border-white/10 bg-surface-400/40 px-2.5 py-1.5 text-2xs font-medium text-muted transition-colors hover:text-white",
        className,
      )}
    >
      {allHidden ? "Show all" : "Hide all"}
    </button>
  );
}

export default ChartLegendToggleAll;
